var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.announcements.length)?_c('v-row',_vm._l((_vm.announcements),function(alert,i){return _c('v-col',{key:i,staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"prominent":alert.type === 'error',"type":alert.type,"title":"Announcement"}},[_vm._v(" "+_vm._s(alert.message)+" ")])],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }